import { computed } from '@angular/core';
import { signalStoreFeature, withComputed, withState } from '@ngrx/signals';
import { translate } from '@thiememeulenhoff/translations';

export type RequestStatus = 'idle' | 'loading' | 'success' | { error: string };

export function toRequestError(
  error: unknown,
  fallback: string = translate('common.error_occurred'),
): Extract<RequestStatus, { error: string }> {
  const message = error instanceof Error ? error.message : fallback;

  return { error: message || fallback };
}

export function withRequestStatus() {
  return signalStoreFeature(
    withState({ requestStatus: 'idle' as RequestStatus }),
    withComputed(({ requestStatus }) => ({
      isLoading: computed(() => requestStatus() === 'loading'),
      isLoaded: computed(() => requestStatus() === 'success'),
      error: computed(() =>
        typeof requestStatus() === 'object'
          ? (requestStatus() as { error: string }).error
          : null,
      ),
    })),
  );
}
